import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-blog',
  templateUrl: './health-blog.component.html',
  styleUrls: ['./health-blog.component.scss']
})
export class HealthBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
